<template>
  <div>
    <form class="needs-validation" @submit.prevent="confirmDeletePackage">
      <div class="form-group">
        <label for="package_id">ID пакета</label>
        <p id="package_id" class="form-control form-control-sm">{{packageData.id}}</p>
      </div>
      <div class="form-group">
        <label for="package_date">Дата платежек в пакете</label>
        <p id="package_date" class="form-control form-control-sm">{{packageData.date}}</p>
      </div>
    </form>
  </div>

</template>

<script>

import axios from "axios";

export default {
  // mixins: [validationMixin],
  name: "DeleteMassPartnerProfitOrderPackage",
  data() {
    return {
      packageData: {
        id: null,
        date: null,
      },
      submitted: false,
      defaultPayer: null,
    }
  },
  mounted() {
  },
  props: {
  },
  watch: {
  },
  computed: {

  },
  validations: {
  },
  methods: {
    setNullFormDate() {
      this.packageData = {
        id: null,
        date: null,
      };
    },
    setCurrentPackageData(id, date) {
      this.packageData = {
        id: id,
        date: date,
      };
    },
    confirmDeletePackage() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.packageData.$touch();
      if (!this.$v.packageData.$invalid) {
        this.$emit('confirmDeletePackage', this.packageData);
      }
    },
    deletePackage(){
      let formData = new FormData();
      formData.append('id', this.packageData.id);
      axios
          .post(`/v1/mass-partner-profit-order-packages/delete`, formData)
          .then(resp => {
            alert('Пакет платежек c id=' + this.packageData.id + ' удален. В него входило ' + resp.data + ' шт. платежек.');
            this.$emit('package-deleted');
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
  },
  created() {

  }
};
</script>

<style scoped lang="css">

</style>
